Object.defineProperty(exports, "__esModule", { value: true });
class AbortablePromise {
    get [Symbol.toStringTag]() {
        return 'promise';
    }
    constructor(executorOrPromise, aborter) {
        this.promise = null;
        this.controller = null;
        this.signal = null;
        this.aborter = null;
        if ('then' in executorOrPromise) {
            if (!aborter) {
                throw new Error('You must provide an `aborter` when supplying a `promise`');
            }
            this.promise = executorOrPromise;
            this.aborter = aborter;
        }
        else {
            if (aborter) {
                throw new Error('You cannot provide an `aborter` when supplying an `executor`');
            }
            this.controller = new AbortController();
            this.signal = this.controller.signal;
            this.promise = new Promise((resolve, reject) => {
                this.signal.addEventListener('abort', () => {
                    reject(new DOMException('Aborted', 'AbortError'));
                });
                new Promise(executorOrPromise).then(resolve).catch(reject);
            });
        }
    }
    /**
     * Cancels the current network request. This will result in a DOMException with
     * the name 'AbortError' being thrown, so handle it accordingly. You can use the
     * `wasAborted` util to help in your catch handler.
     */
    abort() {
        if (this.aborter) {
            this.aborter();
        }
        else if (this.controller) {
            this.controller.abort();
        }
    }
    /**
     * Attaches callbacks for the resolution and/or rejection of the Promise.
     * @param onfulfilled The callback to execute when the Promise is resolved.
     * @param onrejected The callback to execute when the Promise is rejected.
     * @returns A Promise for the completion of which ever callback is executed.
     */
    then(onfulfilled, onrejected) {
        const promise = this.promise.then(onfulfilled, onrejected);
        return new AbortablePromise(promise, () => this.abort());
    }
    /**
     * Attaches a callback for only the rejection of the Promise.
     * @param onrejected The callback to execute when the Promise is rejected.
     * @returns A Promise for the completion of the callback.
     */
    catch(onrejected) {
        const promise = this.promise.catch(onrejected);
        return new AbortablePromise(promise, () => this.abort());
    }
    /**
     * Attaches a callback that is invoked when the Promise is settled (fulfilled or rejected). The
     * resolved value cannot be modified from the callback.
     * @param onfinally The callback to execute when the Promise is settled (fulfilled or rejected).
     * @returns A Promise for the completion of the callback.
     */
    finally(onfinally) {
        const promise = this.promise.finally(onfinally);
        return new AbortablePromise(promise, () => this.abort());
    }
}
exports.default = AbortablePromise;
//# sourceMappingURL=AbortablePromise.js.map